export type PathData = { path: string; exact?: boolean; strict?: boolean };

export const AppPaths: { [name: string]: PathData } = {
  ERROR: { path: "/error", exact: false },
  ICA_PREVIEW_FEATURE: {
    path: "/:submissionId",
    exact: true,
  },
  MOCK_PAGE: {
    path: "/mock/:extractionID",
    exact: true,
  },
};
